import ABRPenaltyCollectionReport from "../../../components/Reports/ABRPenaltyCollectionReport";

const ABRPenaltyCollectionReportPage = () => {
  return <ABRPenaltyCollectionReport />;
};

export default ABRPenaltyCollectionReportPage;
